export const getGiftCardDetails = (state) => state?.giftCardDetails
